import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import SignatureCanvas from 'react-signature-canvas';
import PDF from './PDF2';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import file from '../../images/sample.pdf';
import { connect } from 'react-redux';
import withSizes from 'react-sizes';
import * as actions from '../../store/actions/index';
import { withRouter } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import { Tabs } from "@yazanaabed/react-tabs";
import CircularProgress from '@material-ui/core/CircularProgress';


const styles = theme => ({
    body:{
        backgroundColor: 'grey',
    },
    container: {
        width: '80vw',
        height: '47vh',
        // margin:'10%',
        // alignItem: 'center',
        // margin: '0 Auto',
    },
    containerB: {
        width: '80vw',
        height: '12vh',
        // margin:'10%',
        // alignItem: 'center',
        // margin: '0 Auto',
    },
    containerC:{
        minHeight:'100vh'
    },
    sigContainer: {
        height: '100%',
        width:'100vw',
        // alignItems:'center',
        backgroundColor: '#fff',
    },
    sigPad:{
        backgroundColor: 'white',
        width: '100%',
        height: '100%',
    },
    button: {
        //width: '100%',
        padding:'5px',
        margin:'10px'
    },
    sizeSmall:{
        fontSize: '10px',
    },
    sigImage: {
        backgroundSize: '200px 50px',
        width: '200px',
        height: '200px',
        backgroundColor: 'white',
    },
    pdfMargin:{
        // paddingRight: 10
    },
    bInput: {
        background: "rgba(255, 255, 255, 0.5)",
        outline: "0",
        color: "#99192D",
        // wordWrap: "break-word",
        // wordBreak: "break-all",
        border: "2px solid #99192D",
        textTransform: 'none',
        paddingTop: "15px",
        paddingBottom: "15px",
        borderRadius: "25px",
        // height: "30px",
        marginLeft: "3px",
        marginRight: "3px",
        boxSizing: "border-box",
        fontSize: "16px",
        "&:hover": {
            color: "white",
          },
      },
      root: {
        height: "110vh",
        '@media (max-width: 480px)': {
            height: '75vh'
        },
        '@media (max-width: 510px)': {
          height: '80vh'
        }
      },
});

class SignatureCanvasWrapper extends Component{

    state = {
        trimmedDataURL: null,
        uniqueId: localStorage.getItem('token'),
        fileURL: `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}`,
        signSubmitted:true,
        signatureNotFound: false,
        waitingForSignatureUpdate: false
    }

    sigPad={};

    clear = (name) => {
        this.sigPad[name].clear()
        this.setState({
            signatureNotFound:false
        })
    }

    trim = (name) => {
        this.setState({ waitingForSignatureUpdate : true })
        console.log('Trimming name: '+name)
        console.log('Trimming name: '+JSON.stringify(name))
        let base_data = this.sigPad[name].getTrimmedCanvas().toDataURL('image/png');
        console.log('base_data: '+base_data)
        var len = (''+base_data).length
        var y = 0;
        if ( (''+base_data).includes('==')){
            y = 2
        }
        else if ( (''+base_data).includes('=')){
            y = 1
        }

        var kb = ((len * (3/4))-y)/1000
        console.log('KB: '+kb)
        // x = (n * (3/4)) - y
        // You can calculate the file size (in bytes) using below formula:
        // x = (n * (3/4)) - y
        // Where:
        // 1. x is the size of a file in bytes
        // 2. n is the length of the Base64 String
        // 3. y will be 2 if Base64 ends with '==' and 1 if Base64 ends with '='.

        if (kb <= 2){
            this.setState({
                signatureNotFound:true
            })
        }
        else{
            this.setState({
                signatureNotFound:false
            })
            this.setState({trimmedDataURL : base_data.split(',')[1]});

            let userType = '';
            if(this.props.claimantUniqueId == this.state.uniqueId){
                userType = 'claimant';
            }else if(this.props.respondentUniqueId == this.state.uniqueId){
                userType = 'respondent';
            }

            if (this.props.caseData.agreement_type == 'EstateAgentDispute' && userType == 'respondent'){
                if (localStorage.getItem('typeOfAccount') == 'user'){
                    this.props.uploadSignature(
                        this.props.match.params.id,
                        `${this.props.conversationId}_${userType}_signature_${name.toLowerCase()}.png`,
                        userType,
                        name,
                        base_data
                    );
                }
                else{
                    this.props.uploadSignature(
                        this.props.match.params.id,
                        `${this.props.conversationId}_${localStorage.getItem('typeOfAccount')}_signature_${name.toLowerCase()}.png`,
                        localStorage.getItem('typeOfAccount'),
                        name,
                        base_data
                    );
                }
            }
            else if (this.props.caseData.agreement_type == 'SalesOfGoods'){
                if (localStorage.getItem('typeOfAccount') == 'user'){
                    this.props.uploadSignature(
                        this.props.match.params.id,
                        `${this.props.conversationId}_${userType}_signature_${name.toLowerCase()}.png`,
                        userType,
                        name,
                        base_data
                    );
                }
                else{
                    this.props.uploadSignature(
                        this.props.match.params.id,
                        `${this.props.conversationId}_${localStorage.getItem('typeOfAccount')}_signature_${name.toLowerCase()}.png`,
                        localStorage.getItem('typeOfAccount'),
                        name,
                        base_data
                    );
                }
            }
            else if (this.props.caseData.agreement_type == 'serviceDispute'){
                if (localStorage.getItem('typeOfAccount') == 'user'){
                    this.props.uploadSignature(
                        this.props.match.params.id,
                        `${this.props.conversationId}_${userType}_signature_${name.toLowerCase()}.png`,
                        userType,
                        name,
                        base_data
                    );
                }
                else{
                    this.props.uploadSignature(
                        this.props.match.params.id,
                        `${this.props.conversationId}_${localStorage.getItem('typeOfAccount')}_signature_${name.toLowerCase()}.png`,
                        localStorage.getItem('typeOfAccount'),
                        name,
                        base_data
                    );
                }
            }
            else if (this.props.caseData.agreement_type == 'insuranceDispute'){
                if (localStorage.getItem('typeOfAccount') == 'user'){
                    this.props.uploadSignature(
                        this.props.match.params.id,
                        `${this.props.conversationId}_${userType}_signature_${name.toLowerCase()}.png`,
                        userType,
                        name,
                        base_data
                    );
                }
                else{
                    this.props.uploadSignature(
                        this.props.match.params.id,
                        `${this.props.conversationId}_${localStorage.getItem('typeOfAccount')}_signature_${name.toLowerCase()}.png`,
                        localStorage.getItem('typeOfAccount'),
                        name,
                        base_data
                    );
                }
            }
            else{
                if (localStorage.getItem('typeOfAccount') == 'user'){
                    this.props.uploadSignature(
                        this.props.match.params.id,
                        `${this.props.conversationId}_${userType}_signature.png`,
                        userType,
                        name,
                        base_data
                    );
                }
                else{
                    this.props.uploadSignature(
                        this.props.match.params.id,
                        `${this.props.conversationId}_${localStorage.getItem('typeOfAccount')}_signature.png`,
                        localStorage.getItem('typeOfAccount'),
                        name,
                        base_data
                    );
                }
            }

            this.setState({
                fileURL:"",
                signSubmitted:false
            })  
            var self = this
            setTimeout(()=>{
                console.log('FORCING UPDATE')
                let userType = '';
                
                if(this.props.claimantUniqueId == this.state.uniqueId){
                    userType = 'claimant';
                    this.setState({
                        fileURL:`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}`
                    })  
                }else if(this.props.respondentUniqueId == this.state.uniqueId){
                    userType = 'respondent';
                    this.setState({
                        fileURL: `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}_response`
                    })
                }

                if(this.props.claimantUniqueId == this.state.uniqueId){
                    userType = 'claimant';
                }else if(this.props.respondentUniqueId == this.state.uniqueId){
                    userType = 'respondent';
                }
                // window.location.reload();
                self.setState({ waitingForSignatureUpdate : false })
            },50000)
        }
    
    }
   
    componentWillMount(){
        this.updateFileURL();
    }

    updateFileURL(){
        this.setState({
            fileURL:""
        })  

        setTimeout(()=>{
            console.log('FORCING UPDATE')
            try{
            this.sigPad.clear()
            } catch(err){}
            let userType = '';

            if(this.props.claimantUniqueId == this.state.uniqueId){
                userType = 'claimant';
                this.setState({
                    fileURL:`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}`
                })  
            }else if(this.props.respondentUniqueId == this.state.uniqueId){
                userType = 'respondent';
                this.setState({
                    fileURL: `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}_response`
                })
            }

            // if(this.props.caseData.claimantUniqueId == this.state.uniqueId){
            //     userType = 'claimant';
            //     this.setState({
            //         fileURL:`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}`
            //     })  
            // }
            // else if(this.props.caseData.respondentUniqueId == this.state.uniqueId){
            //     userType = 'respondent';
            //     this.setState({
            //         fileURL: `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}_response`
            //     })
            // }

        },2000)
    }
    
    render(){
        const { classes } = this.props;
        let { trimmedDataURL } = this.state;
        // let fileURL = `${process.env.REACT_APP_SERVER_HOSTNAME}/server/documents/${this.props.conversationId}.pdf`;
        // let fileURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}`;
        let userType = '';
        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType = 'claimant';
        } else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType = 'respondent';
        }

        if (userType == 'respondent'){
            console.log('signatureCanvasWrapper userType: respondent')
            if (this.props.caseData.agreement_type == 'EstateAgentDispute'){
                console.log('signatureCanvasWrapper agreement_type: EstateAgentDispute')

                if (this.props.caseData.a2 == 'purchaser' || this.props.caseData.a2 == 'vendor'){
                    console.log('signatureCanvasWrapper agreement_type: EstateAgentDispute')
                    return(
                        <Grid container spacing={16} alignItems='center' direction='column' justify='center'>
        
                            <Grid container spacing={16} alignItems="center" justify="center" className={classes.containerC} direction='column'>
                            
                            {this.state.signatureNotFound && <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto'}}>{this.context.t('The signature cannot be identified, please sign again.')}<br></br><br></br></h4>}
                                <h4 style={{display: 'block', width: '79%', textAlign: 'center', margin: '0 Auto', color:'#99192D'}}>{this.context.t('Please provide your signature below.')}</h4><br></br>
                                <Card className={classes.container}>
                                    <div className={classes.sigContainer}>
                                        <SignatureCanvas
                                            clearOnResize={false}
                                            canvasProps={{className: classes.sigPad}}
                                            ref= {(ref) => { this.sigPad['a'] = ref }}
                                        />
                                    </div>
                                </Card>
                                {/* <Card className={classes.containerB}> */}
                                <div style={{display: 'block', textAlign: '-webkit-center'}}>
                                    <br></br>
                                    <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto', textTransform:'none'}}>{this.context.t('I certify that information contained in the Response is true and correct and consent to submit the difference to arbitration.')}</h4><br></br>
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            color="primary"
                                            className={classes.bInput}
                                            // classes={{ root: classes.button }}
                                            onClick={this.clear.bind(this,'a')}
                                            // size='small' //assign  it small if its a mobile screen
                                        >
                                            {this.context.t('Reset')}
                                        </Button><br></br><br></br>
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            color="primary"
                                            className={classes.button}
                                            // onClick={this.trim}
                                            onClick={this.trim.bind(this, 'a')}
                                        >
                                            {this.context.t('Submit')}
                                        </Button><br></br><br></br>
                                        <Button
                                            disabled = {this.state.signSubmitted}
                                            variant="contained"
                                            type="submit"
                                            color="primary"
                                            className={classes.bInput}
                                            onClick={this.props.handleComplete}
                                        >
                                            {this.context.t('Confirm Signature')}
                                        </Button>
                                       
                                    </div>
                                {/* </Card>   */}
                                <PDF isDesktop={this.props.isDesktop} file={this.state.fileURL} fileURLNoName={this.state.fileURL} />
                               
                            </Grid>
                        </Grid>                      
                    );
                }
                else{
                    if (this.props.caseData.a1 == 'sole'){
                        console.log('signatureCanvasWrapper a1: sole')

                        if (this.props.caseData.a2 == 'vendor'){
                            console.log('signatureCanvasWrapper a2: vendor')
                            if (this.props.caseData.namesOfVendors !== undefined){
                                return(
                                    <Grid container spacing={16} alignItems='center' direction='column' justify='center'>
                                        <Tabs
                                            // style={{width: '100%'}}
                                            activeTab={{
                                                // id: "tab1"
                                                id:this.props.caseData.namesOfVendors[0].a4
                                            }}
                                            >
                                            {
                                                
                                                this.props.caseData.namesOfVendors.map((name, index) => (
                                                    <Tabs.Tab id={name.a4} title={name.a4}>
                                                    <Grid container spacing={16} alignItems="center" justify="center" className={classes.containerC} direction='row'>
                                                    {this.state.signatureNotFound && <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto'}}>{this.context.t('The signature cannot be identified, please sign again.')}<br></br><br></br></h4>}
                                                        <h4 style={{display: 'block', width: '79%', textAlign: 'center', padding:'5px', margin: '0 Auto', color:'#99192D'}}>{this.context.t('Please provide your signature below.')}: <b>{name.a4}</b></h4><br></br>
                                                        <Card className={classes.container}>
                                                            <div className={classes.sigContainer}>
                                                                <SignatureCanvas
                                                                    // style={{width: '50%'}}
                                                                    clearOnResize={false}
                                                                    canvasProps={{className: classes.sigPad}}
                                                                    ref= { (ref) => { this.sigPad[name.a4] = ref }}
                                                                />
                                                            </div>
                                                        </Card>  

                                                        {/* <Card className={classes.containerB}> */}
                                                        <div style={{display: 'block', textAlign: '-webkit-center'}}>
                                                                <br></br>
                                                                <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto', textTransform:'none'}}>{this.context.t('I certify that information contained in the Response is true and correct and consent to submit the difference to arbitration.')}</h4><br></br>
                                                                <Button
                                                                    variant="contained"
                                                                    type="submit"
                                                                    color="primary"
                                                                    className={classes.bInput}
                                                                    // classes={{ root: classes.button }}
                                                                    onClick={this.clear.bind(this,name.a4)}
                                                                    // size='small' //assign  it small if its a mobile screen
                                                                >
                                                                    {this.context.t('Reset')}
                                                                </Button><br></br><br></br>
                                                                <Button
                                                                    variant="contained"
                                                                    type="submit"
                                                                    color="primary"
                                                                    className={classes.bInput}
                                                                    // onClick={this.trim}
                                                                    onClick={this.trim.bind(this, name.a4)}
                                                                    
                                                                >
                                                                    {this.context.t('Submit')}
                                                                </Button><br></br><br></br>
                                                                <Button
                                                                    disabled = {this.state.signSubmitted}
                                                                    variant="contained"
                                                                    type="submit"
                                                                    color="primary"
                                                                    className={classes.bInput}
                                                                    onClick={this.props.handleComplete}
                                                                >
                                                                    {this.context.t('Confirm Signature')}
                                                                </Button>
                                                                
                                                            </div>
                                                        {/* </Card>  */}
                                                    </Grid>
                                                    </Tabs.Tab>
                                                ))
                                            }
                                        </Tabs>
                                        <Grid >
                                            <PDF isDesktop={this.props.isDesktop} fileURLNoName={this.state.fileURL} file={this.state.fileURL}/>
                                        </Grid>
                                    </Grid>                      
                                );
                            }
                        }
                        else if (this.props.caseData.a2 == 'purchaser'){
                            console.log('signatureCanvasWrapper a2: purchaser')
                            if (this.props.caseData.namesOfPurchasers !== undefined){
                                return(
                                    <Grid container spacing={16} alignItems='center' direction='column' justify='center'>
                                        <Tabs
                                            // style={{width: '100%'}}
                                            activeTab={{
                                                // id: "tab1"
                                                id:this.props.caseData.namesOfPurchasers[0].a12a
                                            }}
                                            >
                                            {
                                                
                                                this.props.caseData.namesOfPurchasers.map((name, index) => (
                                                    <Tabs.Tab id={name.a12a} title={name.a12a}>
                                                    <Grid container spacing={16} alignItems="center" justify="center" className={classes.containerC} direction='row'>
                                                    {this.state.signatureNotFound && <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto'}}>{this.context.t('The signature cannot be identified, please sign again.')}<br></br><br></br></h4>}
                                                        <h4 style={{display: 'block', width: '79%', textAlign: 'center', padding:'5px', margin: '0 Auto', color:'#99192D'}}>{this.context.t('Please provide your signature below.')}: <b>{name.a12a}</b></h4><br></br>
                                                        <Card className={classes.container}>
                                                            <div className={classes.sigContainer}>
                                                                <SignatureCanvas
                                                                    // style={{width: '50%'}}
                                                                    clearOnResize={false}
                                                                    canvasProps={{className: classes.sigPad}}
                                                                    ref= { (ref) => { this.sigPad[name.a12a] = ref }}
                                                                />
                                                            </div>
                                                        </Card>  

                                                        <div style={{display: 'block', textAlign: '-webkit-center'}}>
                                                                <br></br>
                                                                <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto', textTransform:'none'}}>{this.context.t('I certify that information contained in the Response is true and correct and consent to submit the difference to arbitration.')}</h4><br></br>
                                                                <Button
                                                                    variant="contained"
                                                                    type="submit"
                                                                    color="primary"
                                                                    className={classes.bInput}
                                                                    // classes={{ root: classes.button }}
                                                                    onClick={this.clear.bind(this,name.a12a)}
                                                                    // size='small' //assign  it small if its a mobile screen
                                                                >
                                                                    {this.context.t('Reset')}
                                                                </Button><br></br><br></br>
                                                                <Button
                                                                    variant="contained"
                                                                    type="submit"
                                                                    color="primary"
                                                                    className={classes.bInput}
                                                                    // onClick={this.trim}
                                                                    onClick={this.trim.bind(this, name.a12a)}
                                                                    
                                                                >
                                                                    {this.context.t('Submit')}
                                                                </Button><br></br><br></br>
                                                                <Button
                                                                    disabled = {this.state.signSubmitted}
                                                                    variant="contained"
                                                                    type="submit"
                                                                    color="primary"
                                                                    className={classes.bInput}
                                                                    onClick={this.props.handleComplete}
                                                                >
                                                                    {this.context.t('Confirm Signature')}
                                                                </Button>
                                                               
                                                           
                                                        </div>  
                                                    </Grid>
                                                    </Tabs.Tab>
                                                ))
                                            }
                                            </Tabs>
                                        <Grid >
                                            <PDF isDesktop={this.props.isDesktop} fileURLNoName={this.state.fileURL} file={this.state.fileURL}/>
                                        </Grid>
                                    </Grid>                      
                                );
                        }

                    }
                    }
                    else if (this.props.caseData.a1 == 'seperate'){
                        console.log('signatureCanvasWrapper a1: seperate')
                        if (this.props.caseData.namesOfA2 !== undefined){
                            return(
                                <Grid container spacing={16} alignItems='center' direction='column' justify='center'>
                                    <Tabs
                                        // style={{width: '100%'}}
                                        activeTab={{
                                            // id: "tab1"
                                            id:this.props.caseData.namesOfA2[0].a4
                                        }}
                                        >
                                        {
                                            
                                            this.props.caseData.namesOfA2.map((name, index) => (
                                                <Tabs.Tab id={name.a4} title={name.a4}>
                                                <Grid container spacing={16} alignItems="center" justify="center" className={classes.containerC} direction='row'>
                                                {this.state.signatureNotFound && <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto'}}>{this.context.t('The signature cannot be identified, please sign again.')}<br></br><br></br></h4>}
                                                    <h4 style={{display: 'block', width: '79%', textAlign: 'center', padding:'5px', margin: '0 Auto', color:'#99192D'}}>{this.context.t('Please provide your signature below.')}: <b>{name.a4}</b></h4><br></br>
                                                    <Card className={classes.container}>
                                                        <div className={classes.sigContainer}>
                                                            <SignatureCanvas
                                                                // style={{width: '50%'}}
                                                                clearOnResize={false}
                                                                canvasProps={{className: classes.sigPad}}
                                                                ref= { (ref) => { this.sigPad[name.a4] = ref }}
                                                            />
                                                        </div>
                                                    </Card>  
                                                    <div style={{display: 'block', textAlign: '-webkit-center'}}>
                                                                <br></br>
                                                                <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto', textTransform:'none'}}>{this.context.t('I certify that information contained in the Response is true and correct and consent to submit the difference to arbitration.')}</h4><br></br>
                                                            <Button
                                                                variant="contained"
                                                                type="submit"
                                                                color="primary"
                                                                className={classes.bInput}
                                                                // classes={{ root: classes.button }}
                                                                onClick={this.clear.bind(this,name.a4)}
                                                                // size='small' //assign  it small if its a mobile screen
                                                            >
                                                                {this.context.t('Reset')}
                                                            </Button><br></br><br></br>
                                                            <Button
                                                                variant="contained"
                                                                type="submit"
                                                                color="primary"
                                                                className={classes.bInput}
                                                                // onClick={this.trim}
                                                                onClick={this.trim.bind(this, name.a4)}
                                                                
                                                            >
                                                                {this.context.t('Submit')}
                                                            </Button><br></br><br></br>
                                                            <Button
                                                                disabled = {this.state.signSubmitted}
                                                                variant="contained"
                                                                type="submit"
                                                                color="primary"
                                                                className={classes.bInput}
                                                                onClick={this.props.handleComplete}
                                                            >
                                                                {this.context.t('Confirm Signature')}
                                                            </Button>
                                                            
                                                    </div>  
                                                </Grid>
                                                </Tabs.Tab>
                                            ))
                                        }
                                        </Tabs>
                                    <Grid >
                                        <PDF isDesktop={this.props.isDesktop} fileURLNoName={this.state.fileURL} file={this.state.fileURL}/>
                                    </Grid>
                                </Grid>                       
                            );
                        }
                    }
                }

                
                
            }
            else if (this.props.caseData.agreement_type == 'MoneyLent'){
                console.log('signatureCanvasWrapper agreement_type: MoneyLent')
                return(
                    // <Grid container spacing={16} alignItems='center' direction='row' justify='center'>
    
                        <Grid container spacing={16} alignItems="center" justify="center" className={classes.containerC} direction='column'>
                        {this.state.signatureNotFound && <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto'}}>{this.context.t('The signature cannot be identified, please sign again.')}<br></br><br></br></h4>}
                            <h4 style={{display: 'block', width: '79%', textAlign: 'center', margin: '0 Auto', color:'#99192D'}}>{this.context.t('Please provide your signature below.')}</h4><br></br>
                            <Card className={classes.container}>
                                <div className={classes.sigContainer}>
                                    <SignatureCanvas
                                        clearOnResize={false}
                                        canvasProps={{className: classes.sigPad}}
                                        ref= {(ref) => { this.sigPad['a'] = ref }}
                                    />
                                </div>
                            </Card>  
                            <div style={{display: 'block', textAlign: '-webkit-center'}}>
                                <br></br>
                                <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto', textTransform:'none'}}>{this.context.t('I certify that information contained in the Response is true and correct and consent to submit the difference to arbitration.')}</h4><br></br>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.bInput}
                                        // classes={{ root: classes.button }}
                                        onClick={this.clear.bind(this,'a')}
                                        // size='small' //assign  it small if its a mobile screen
                                    >
                                        {this.context.t('Reset')}
                                    </Button><br></br><br></br>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.bInput}
                                        // onClick={this.trim}
                                        onClick={this.trim.bind(this, 'a')}
                                    >
                                        {this.context.t('Submit')}
                                    </Button><br></br><br></br>
                                    <Button
                                        disabled = {this.state.signSubmitted}
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.bInput}
                                        onClick={this.props.handleComplete}
                                    >
                                        {this.context.t('Confirm Signature')}
                                    </Button>
                            </div>  
                            <Grid >
                                <PDF isDesktop={this.props.isDesktop} fileURLNoName={this.state.fileURL} file={this.state.fileURL}/>
                            </Grid>
                        </Grid>
                    // </Grid>                      
                );
            }
            else if (this.props.caseData.agreement_type == 'SalesOfGoods'){
                console.log('signatureCanvasWrapper agreement_type: SalesOfGoods')
                return(
                    <Grid container spacing={16} alignItems='center' direction='row' justify='center'>
    
                        <Grid container spacing={16} alignItems="center" justify="center" className={classes.containerC} direction='row'>
                        {this.state.signatureNotFound && <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto'}}>{this.context.t('The signature cannot be identified, please sign again.')}<br></br><br></br></h4>}
                            <h4 style={{display: 'block', width: '79%', textAlign: 'center', margin: '0 Auto', color:'#99192D'}}>{this.context.t('Please provide your signature below.')}</h4><br></br>
                            <Card className={classes.container}>
                                <div className={classes.sigContainer}>
                                    <SignatureCanvas
                                        clearOnResize={false}
                                        canvasProps={{className: classes.sigPad}}
                                        ref= {(ref) => { this.sigPad['a'] = ref }}
                                    />
                                </div>
                            </Card>  
                            <div style={{display: 'block', textAlign: '-webkit-center'}}>
                                <br></br>
                                <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto', textTransform:'none'}}>{this.context.t('I certify that information contained in the Response is true and correct and consent to submit the difference to arbitration.')}</h4><br></br>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        //className={classes.button}
                                        classes={{ root: classes.bInput }}
                                        onClick={this.clear.bind(this,'a')}
                                        // size='small' //assign  it small if its a mobile screen
                                    >
                                        {this.context.t('Reset')}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.bInput}
                                        // onClick={this.trim}
                                        onClick={this.trim.bind(this, 'a')}
                                    >
                                        {this.context.t('Submit')}
                                    </Button>
                                    <Button
                                        disabled = {this.state.signSubmitted}
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.bInput}
                                        onClick={this.props.handleComplete}
                                    >
                                        {this.context.t('Confirm Signature')}
                                    </Button>
                                    
                            </div>  
                            <Grid >
                                <PDF isDesktop={this.props.isDesktop} fileURLNoName={this.state.fileURL} file={this.state.fileURL}/>
                            </Grid>
                        </Grid>
                    </Grid>                      
                );
            }
            else if (this.props.caseData.agreement_type == 'serviceDispute'){
                console.log('signatureCanvasWrapper agreement_type: serviceDispute')
                return(
                    <Grid container spacing={16} alignItems='center' direction='row' justify='center'>
    
                        <Grid container spacing={16} alignItems="center" justify="center" className={classes.containerC} direction='row'>
                        {this.state.signatureNotFound && <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto'}}>{this.context.t('The signature cannot be identified, please sign again.')}<br></br><br></br></h4>}
                            <h4 style={{display: 'block', width: '79%', textAlign: 'center', margin: '0 Auto', color:'#99192D'}}>{this.context.t('Please provide your signature below.')}</h4><br></br>
                            <Card className={classes.container}>
                                <div className={classes.sigContainer}>
                                    <SignatureCanvas
                                        clearOnResize={false}
                                        canvasProps={{className: classes.sigPad}}
                                        ref= {(ref) => { this.sigPad['a'] = ref }}
                                    />
                                </div>
                            </Card>  
                            <div style={{display: 'block', textAlign: '-webkit-center'}}>
                                <br></br>
                                <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto', textTransform:'none'}}>{this.context.t('I certify that information contained in the Response is true and correct and consent to submit the difference to arbitration.')}</h4><br></br>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        //className={classes.button}
                                        classes={{ root: classes.bInput }}
                                        onClick={this.clear.bind(this,'a')}
                                        // size='small' //assign  it small if its a mobile screen
                                    >
                                        {this.context.t('Reset')}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.bInput}
                                        // onClick={this.trim}
                                        onClick={this.trim.bind(this, 'a')}
                                    >
                                        {this.context.t('Submit')}
                                    </Button>
                                    <Button
                                        disabled = {this.state.signSubmitted}
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.bInput}
                                        onClick={this.props.handleComplete}
                                    >
                                        {this.context.t('Confirm Signature')}
                                    </Button>
                                    
                            </div>  
                            <Grid >
                                <PDF isDesktop={this.props.isDesktop} fileURLNoName={this.state.fileURL} file={this.state.fileURL}/>
                            </Grid>
                        </Grid>
                    </Grid>                      
                );
            }
            else if (this.props.caseData.agreement_type == 'insuranceDispute'){
                console.log('signatureCanvasWrapper agreement_type: serviceDispute')
                return(
                    <Grid container spacing={16} alignItems='center' direction='row' justify='center'>
    
                        <Grid container spacing={16} alignItems="center" justify="center" className={classes.containerC} direction='row'>
                        {this.state.signatureNotFound && <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto'}}>{this.context.t('The signature cannot be identified, please sign again.')}<br></br><br></br></h4>}
                            <h4 style={{display: 'block', width: '79%', textAlign: 'center', margin: '0 Auto', color:'#99192D'}}>{this.context.t('Please provide your signature below.')}</h4><br></br>
                            <Card className={classes.container}>
                                <div className={classes.sigContainer}>
                                    <SignatureCanvas
                                        clearOnResize={false}
                                        canvasProps={{className: classes.sigPad}}
                                        ref= {(ref) => { this.sigPad['a'] = ref }}
                                    />
                                </div>
                            </Card>  
                            <div style={{display: 'block', textAlign: '-webkit-center'}}>
                                <br></br>
                                <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto', textTransform:'none'}}>{this.context.t('I certify that information contained in the Response is true and correct and consent to submit the difference to arbitration.')}</h4><br></br>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        //className={classes.button}
                                        classes={{ root: classes.bInput }}
                                        onClick={this.clear.bind(this,'a')}
                                        // size='small' //assign  it small if its a mobile screen
                                    >
                                        {this.context.t('Reset')}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.bInput}
                                        // onClick={this.trim}
                                        onClick={this.trim.bind(this, 'a')}
                                    >
                                        {this.context.t('Submit')}
                                    </Button>
                                    <Button
                                        disabled = {this.state.signSubmitted}
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.bInput}
                                        onClick={this.props.handleComplete}
                                    >
                                        {this.context.t('Confirm Signature')}
                                    </Button>
                                    
                            </div>  
                            <Grid >
                                <PDF isDesktop={this.props.isDesktop} fileURLNoName={this.state.fileURL} file={this.state.fileURL}/>
                            </Grid>
                        </Grid>
                    </Grid>                      
                );
            }

        }

        if (userType == 'claimant'){
            console.log('signatureCanvasWrapper userType: claimant')
            return(
                    <Grid container spacing={16} alignItems="center" justify="center" className={classes.root} direction='row'>
                        {this.state.signatureNotFound && <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto'}}>{this.context.t('The signature cannot be identified, please sign again.')}<br></br><br></br></h4>}
                        
                        <Card className={classes.container}>
                            <div className={classes.sigContainer}>
                            <h4 style={{display: 'block', width: '79%', textAlign: 'center', fontSize:'15px', color:'#99192D'}}>{this.context.t('Please provide your signature below')}</h4><br></br>
                                <SignatureCanvas
                                    clearOnResize={false}
                                    canvasProps={{className: classes.sigPad}}
                                    ref= {(ref) => { this.sigPad['a'] = ref }}
                                />
                            </div>
                        </Card><br></br>
                            <div style={{display: 'block', textAlign: '-webkit-center'}}>
                                    <br></br>
                                    <Button
                                        disabled
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        style={{background:'white', color:'black', textTransform:'none'}}
                                        onClick={this.props.handleComplete}
                                    >
                                        {this.context.t('I certify that information contained in the Arbitration Notice is true and correct.')}
                                    </Button><br></br><br></br>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.bInput}
                                        // classes={{ root: classes.button }}
                                        onClick={this.clear.bind(this,'a')}
                                        // size='small' //assign  it small if its a mobile screen
                                        >
                                        {this.context.t('Reset')}
                                    </Button><br></br><br></br>
                                    {!this.state.waitingForSignatureUpdate && <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.bInput}
                                        // onClick={this.trim}
                                        onClick={this.trim.bind(this, 'a')}
                                    >
                                        {this.context.t('Submit')}
                                    </Button>}
                                    {this.state.waitingForSignatureUpdate && <CircularProgress
                                        size={50}
                                        thickness={3}
                                        className={classes.progress}
                                    />}
                                    <br></br><br></br>
                                    <Button
                                        disabled = {this.state.signSubmitted}
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.bInput}
                                        onClick={this.props.handleComplete}
                                    >
                                        {this.context.t('Confirm Signature')}
                                    </Button>
                            </div>
                        <PDF isDesktop={this.props.isDesktop} fileURLNoName={this.state.fileURL} file={this.state.fileURL}/>
                    </Grid>          
            );
        }

        if (localStorage.getItem('typeOfAccount') == 'arbitrator' || localStorage.getItem('typeOfAccount') == 'admin'){
            return(
                <Grid container spacing={16} alignItems="center" justify="center" className={classes.containerC} direction='row'>
                    {this.state.signatureNotFound && <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto'}}>{this.context.t('The signature cannot be identified, please sign again.')}<br></br><br></br></h4>}
                        <h4 style={{display: 'block', width: '79%', textAlign: 'center', margin: '0 Auto', color:'#99192D',}}>{this.context.t('Please provide your signature below')}</h4><br></br>
                        <Card className={classes.container}>
                            <div className={classes.sigContainer}>
                                <SignatureCanvas
                                    clearOnResize={false}
                                    canvasProps={{className: classes.sigPad}}
                                    ref= {(ref) => { this.sigPad['a'] = ref }}
                                />
                            </div>
                        </Card>  
                        {/* <Card className={classes.containerB}> */}
                            <div style={{display: 'block', textAlign: '-webkit-center'}}>
                                    <br></br>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    className={classes.bInput}
                                    // classes={{ root: classes.button }}
                                    onClick={this.clear.bind(this,'a')}
                                    // size='small' //assign  it small if its a mobile screen
                                >
                                    {this.context.t('Reset')}
                                </Button><br></br><br></br>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    className={classes.bInput}
                                    // onClick={this.trim}
                                    onClick={this.trim.bind(this, 'a')}
                                >
                                    {this.context.t('Submit')}
                                </Button><br></br><br></br>
                                <Button
                                    disabled = {this.state.signSubmitted}
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    className={classes.bInput}
                                    onClick={this.props.handleComplete}
                                >
                                    {this.context.t('Confirm Signature')}
                                </Button>
                            </div>
                        {/* </Card>   */}
                    </Grid>
                );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        conversationId: state.caseInfo.conversationId,
        caseId: state.caseInfo.caseId,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
        claimant_name: state.caseInfo.claimant_name,
        respondent_name: state.caseInfo.respondent_name,
        userType: state.caseInfo.userType,
        caseData: state.caseInfo.caseData,
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
        uploadSignature: (caseId, file_name, userType, name, base_data) => dispatch(actions.uploadSignature(caseId, file_name, userType, name, base_data)),
    }
  }

  const mapSizesToProps = sizes => ({
    isMobile: withSizes.isMobile(sizes),
    isTablet : withSizes.isTablet(sizes),
    isDesktop : withSizes.isDesktop(sizes),
    isGtMobile : withSizes.isGtMobile(sizes),
    isGtTablet : withSizes.isGtTablet(sizes),
    isStTablet : withSizes.isStTablet(sizes),
    isStDesktop : withSizes.isStDesktop(sizes),
    isTabletAndGreater : withSizes.isTabletAndGreater(sizes),
    isTabletAndSmaller : withSizes.isTabletAndSmaller(sizes),

})

  SignatureCanvasWrapper.contextTypes = {
    t: PropTypes.func
  }

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withSizes(mapSizesToProps) (withRouter(SignatureCanvasWrapper))) );